import client from '../httpClient';

const simulatorJudgementApi = (params) => {
  return client.post('/simulator/judgement', JSON.stringify(params));
};

export default simulatorJudgementApi;
